export default __webpack_public_path__ + "static/media/Ancient War Scythe.85dadd13.jpg";